import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios'
import { getTokenCookie, removeTokenCookie, setTokenCookie } from '@lib/token'

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 60000,
  withCredentials: true,
})

export const branchWebHttp = axios.create({
  baseURL: import.meta.env.VITE_BRANCH_WEB_API_URL,
  timeout: 60000,
})

const setAuthToken = (config: InternalAxiosRequestConfig) => {
  if (import.meta.env.VITE_ENV === 'development') {
    const token = getTokenCookie()
    if (token) config.headers.Authorization = `Bearer ${token}`
  }
  return config
}

const setAuthCookie = (res: AxiosResponse) => {
  if (
    res.headers &&
    res.headers.authorization &&
    import.meta.env.VITE_ENV === 'development'
  ) {
    setTokenCookie(res.headers.authorization)
  }
  return res
}

const reject = (error: AxiosError) => {
  return Promise.reject(error)
}

const removeAuthCookie = (err: AxiosError) => {
  if (err && err.response && err.response.status === 401) {
    removeTokenCookie()
  }
  return reject(err)
}

http.interceptors.request.use(setAuthToken, reject)
http.interceptors.response.use(setAuthCookie, removeAuthCookie)

branchWebHttp.interceptors.request.use(setAuthToken, reject)
branchWebHttp.interceptors.response.use(setAuthCookie, removeAuthCookie)
